import {
  AppCard,
  Button,
  Icon,
  PageContainer,
  RouteIconButtonLink,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiEye } from "@mdi/js";
import {
  Alert,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { UserInfoBadge } from "../../../components/molecules/UserInfoBadge";
import { fetchAssignConditionsUsersList } from "../../../services/assignConditions";

export const AssignConditionsUsersTable: React.FC = () => {
  const { t } = useTranslation();
  const {
    data: assignConditionsUsersList,
    isError,
    isLoading,
    refetch,
  } = useQuery({
    queryFn: async () => {
      const response = await fetchAssignConditionsUsersList();
      return response.results;
    },
    queryKey: ["assignConditions", "usersList"],
  });

  if (isLoading) {
    return (
      <AppCard>
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <CircularProgress />
        </Box>
      </AppCard>
    );
  }

  if (isError) {
    return (
      <AppCard>
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Alert
            action={
              <Button onClick={() => void refetch()} variant="outlined">
                {t("common.retry", { defaultValue: "Retry" })}
              </Button>
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {t("assignConditions.usersListError", {
              defaultValue: "Unable to load users list.",
            })}
          </Alert>
        </Box>
      </AppCard>
    );
  }

  return (
    <AppCard>
      {assignConditionsUsersList ? (
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>{t("assignConditions.name")}</TableCell>
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {assignConditionsUsersList.map((user) => (
              <TableRow key={user.id}>
                <TableCell>
                  <UserInfoBadge
                    info={user.full_name}
                    photoUser={user}
                    subInfo={user.login}
                  />
                </TableCell>
                <TableCell align="right">
                  <RouteIconButtonLink
                    params={{ userId: String(user.id) }}
                    to="/mm_request_weekly_goals/$userId"
                  >
                    <Icon icon={mdiEye} />
                  </RouteIconButtonLink>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Alert severity="warning" sx={{ width: "100%" }}>
            {t("assignConditions.emptyUsersList", {
              defaultValue: "No users found.",
            })}
          </Alert>
        </Box>
      )}
    </AppCard>
  );
};

const RouteComponent: React.FC = () => {
  return (
    <PageContainer title="MM - WeeklyGoals">
      <AssignConditionsUsersTable />
    </PageContainer>
  );
};

export const Route = createFileRoute("/_private/mm_request_weekly_goals/")({
  component: RouteComponent,
});
